<div class="create_popup">
    <div class="modal-body">
        
        <form [formGroup]="parentForm">
            <div class="col-lg-12 d-flex align-right justify-content-end mb-15">
                <button type="button" class="btn btn-primary position-right" (click)="addProjectListModal=true">Additional Project</button>
            </div>
            <div formArrayName="worklogs" class="position-relative">
                <div class="product-row" *ngFor="let formGroup of formArray.controls; let i = index" [formGroupName]="i">
                    <div class="row">
                        <!-- Project -->
                    <div class="col-md-2 col-sm-6 mb-1px">
                        <div class="col-md-12" *ngIf="i == 0">
                            <b>Project<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <ng-select class="full-width-option" [multiple]="false" formControlName="projectId" appendTo="body" placeholder="Select Project">
                                <ng-option *ngFor="let item of employeeProjectList" [value]="item?.projectId">
                                    {{ item?.projectName }}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>

                    
                    <!-- Log Date -->
                    <div class="col-md-2 col-sm-6 mb-1px ">
                        <div class="col-md-12" *ngIf="i == 0">
                            <b>Log Date<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12 DateTime">
                            <p-calendar
                                (onSelect)="setLogDate2($event, i)"
                                dateFormat="dd-mm-yy"
                                formControlName="logDate"
                                appendTo="body"
                                [maxDate]="dateTime"
                                class="scheduledDate form-control"
                            ></p-calendar>
                        </div>
                    </div>

                    <!-- Hours -->
                    <div class="col-md-2 col-sm-6 mb-1px">
                        <div class="col-md-12" *ngIf="i == 0">
                            <b>Hours/Minutes<span style="color:red">*</span>: </b>
                        </div>
                        <div class="row">
                            <div class="col-md-5 px-1">
                                <input type="text" class="form-control" placeholder="00" formControlName="hr" />
                            </div>
                            <span class="col-md-1 px-1">:</span>
                            <div class="col-md-5 px-1">
                                <input type="text" class="form-control"  placeholder="00" formControlName="min" />
                            </div>
                        </div>
                    </div>

                    <!-- Start Time -->
                    <div class="col-md-2 col-sm-6 mb-1px">
                        <div class="col-md-12" *ngIf="i == 0">
                            <b>Start Time: </b>
                        </div>
                        <div class="col-md-12 DateTime">
                            <!-- <p-calendar (onSelect)="selectTime2($event, i, 'start')" (onFocus)="focus($event)" [timeOnly]="true" formControlName="start" 
                            appendTo="body" class="scheduledDate form-control"></p-calendar> -->
                            <!-- <input [ngxMatTimepicker]="picker" class="form-control" (focus)="focus($event)" formControlName="start" >
                            <ngx-mat-timepicker #picker appendTo="div" class="matTimePicker"></ngx-mat-timepicker>   -->
                            <input type="time" class="form-control" (focus)="focus($event)" step="2" formControlName="start" name="start" >
                        </div>
                    </div>

                    <!-- Title -->
                    <div class="col-md-2 col-sm-6 mb-1px">
                        <div class="col-md-12" *ngIf="i == 0">
                            <b>Task<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" formControlName="title" />
                        </div>
                    </div>
        
                    <!-- Task Description -->
                    <div class="col-md-2 col-sm-6 mb-1px">
                        <div class="col-md-12" *ngIf="i == 0">
                            <b>Remark </b>
                        </div>
                        <div class="col-md-12">
                            <textarea type="text" class="form-control customTextarea" cols="1" rows="1" formControlName="taskDescription"></textarea>
                        </div>
                    </div>
        
                    <!-- End Time -->
                    <!-- <div class="col-md-2 col-sm-6 mb-2">
                        <div class="col-md-12">
                            <b>End Time<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12 DateTime">
                            <p-calendar (onSelect)="selectTime2($event, i, 'end')" [timeOnly]="true" formControlName="end"
                            appendTo="body" class="scheduledDate form-control"></p-calendar>
                        </div>
                    </div> -->
        
                    <!-- Delete Button -->
                    <!-- <span *ngIf="formArray.length > 1 && i == (formArray.length -1)" class="deleteIcon" (click)="removeForm(i)">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#616161"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10 11V17" stroke="#616161" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 11V17" stroke="#616161" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4 7H20" stroke="#616161" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke="#616161" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#616161" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </span> -->
                    <!-- <div class="col-md-2 col-sm-6 mb-2" *ngIf="formArray.length > 1">
                        <div class="col-md-12">

                            <button type="button" class="btn btn-danger" (click)="removeForm(i)">Delete</button>
                        </div>
                    </div> -->

                    <!-- Copy ICON -->
                    <span *ngIf="formArray.length > 1 && i == (formArray.length -1)" class="deleteIcon" (click)="copy(formGroup,i)">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#313131"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M10 8V7C10 6.05719 10 5.58579 10.2929 5.29289C10.5858 5 11.0572 5 12 5H17C17.9428 5 18.4142 5 18.7071 5.29289C19 5.58579 19 6.05719 19 7V12C19 12.9428 19 13.4142 18.7071 13.7071C18.4142 14 17.9428 14 17 14H16M7 19H12C12.9428 19 13.4142 19 13.7071 18.7071C14 18.4142 14 17.9428 14 17V12C14 11.0572 14 10.5858 13.7071 10.2929C13.4142 10 12.9428 10 12 10H7C6.05719 10 5.58579 10 5.29289 10.2929C5 10.5858 5 11.0572 5 12V17C5 17.9428 5 18.4142 5.29289 18.7071C5.58579 19 6.05719 19 7 19Z" stroke="#6e6e6e" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
                    </span>
        
                </div>
                <div class="d-flex align-items-end justify-content-end mt-2">
                    <p class="btn btn-primary mb-0 mr-6" *ngIf="i == (formArray.length - 1) && !editTrue && !editCalender" (click)="submitData(formGroup,i)" [ngClass]="{disabled: !parentForm.valid}"><span>Submit</span></p>
                    <p class="btn btn-primary mb-0" *ngIf="i == (formArray.length - 1)" [ngClass]="{disabled: !parentForm.valid}" (click)="addForm(formGroup,i)">
                        <span *ngIf="!editTrue && !editCalender">
                         + Add more
                        </span>
                        <span *ngIf="editTrue || editCalender">
                         Update
                        </span>
                     </p>
                </div>
            </div>
                            
            </div>
            <div class="col-md-12 text-right">
                <!-- <button type="button" class="btn btn-success" (click)="addForm()">Add</button> -->
                <!-- <button type="submit" [disabled]="!parentForm.valid" class="btn btn-primary">Submit</button> -->
            </div>
        </form>
    </div>
</div>

<p-dialog header="Add Addition Projects" [modal]="true" [(visible)]="addProjectListModal" [style]="{ width: '25rem' }">
    <form #AddAdditionalProjectForm="ngForm" (ngSubmit)="addAdditionProject()">
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-12">
                <div class="col-md-12">
                    <b>Project<span style="color:red">*</span>: </b>
                </div>
                <div class="col-md-12">
                    <ng-select [multiple]="true" [(ngModel)]="selectedProjects" name="additionProject" appendTo="body" placeholder="Select Project">
                        <ng-option *ngFor="let item of projectLists" [value]="item">
                            {{ item?.projectName }}
                        </ng-option>
                    </ng-select>
                </div>
        </div>
    </div>   
    <div class="row mt-3">
        <div class="col-lg-12 align-right">
            <button class="btn btn-submit me-2" type="submit" >Add</button>
            <a (click)="addProjectListModal = false" class="btn btn-cancel ">No</a>
        </div>
    </div>
  </form>
  </p-dialog>

